import { createStyleComponent, emptyCSSTemplateFunc } from "@hzero-front-ui/core";
var getcascaderStyle = emptyCSSTemplateFunc;
export default createStyleComponent("comp/cascader", getcascaderStyle);